import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../actions';

function PrintDocument({ data }) {
  const imageIframe = useRef();
  const [currentFile, setCurrentFile] = useState(data[0].url);
  const options = useMemo(() => {
    if (data && data.length > 0) {
      return data.map((item, index) => ({
        label: `Document ${index + 1}`,
        value: item?.url,
        type: item?.file_type,
      }));
    }
    return null;
  });
  const setModal = useContext(ModalContext);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (e) => {
    setCurrentFile(e.value);
  };

  const createIframeContent = (url) => {
    const iframeDoc = imageIframe.current?.contentDocument;
    if (iframeDoc) {
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Document</title>
          <style>
            body {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 90vh;
              margin: 0;
              background-color: #f8f9fa;
              padding-top: 25px;
            }
            img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }
          </style>
        </head>
        <body>
          <img src="${url}" alt="Document" />
        </body>
        </html>
      `;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }
  };

  const handlePrintImageIframe = () => {
    if (imageIframe.current) {
      imageIframe.current.contentWindow.focus();
      imageIframe.current.contentWindow.print();
    }
  };
  const downloadImage = async (url, filename) => {
    try {
      const response = await fetch(url, { mode: 'cors' });
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename || 'downloaded-file';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error downloading the file:', error);
    }
  };

  useEffect(() => {
    if (
      currentFile &&
      options.find((option) => option.value === currentFile)?.type !==
        'application/pdf'
    )
      createIframeContent(currentFile);
  }, [currentFile, options]);

  return (
    <Modal.Body>
      <div className="d-flex flex-column">
        <div className="d-flex flex-column mb-3">
          <div className="mb-3">
            <Select
              name="document"
              placeholder="Select document"
              onChange={handleOnChange}
              options={options}
              value={options.find((option) => option.value === currentFile)}
            />
          </div>
          <div
            className={`${
              options.find((option) => option.value === currentFile)?.type !==
              'application/pdf'
                ? 'd-flex flex-column'
                : 'd-none'
            } justify-content-center align-items-center overflow-auto border border-dark`}
            style={{
              height: '600px',
            }}
          >
            <div className="d-flex bg-dark justify-content-end w-100 p-3">
              <button
                type="button"
                onClick={() =>
                  downloadImage(
                    currentFile,
                    `${
                      options.find((option) => option.value === currentFile)
                        ?.label
                        ? options
                            .find((option) => option.value === currentFile)
                            ?.label.replace(/ /g, '_')
                        : 'document'
                    }.jpg`
                  )
                }
                className="btn-blank"
              >
                <i className="fas fa-download icon-print bg-dark" />
              </button>
              <button
                type="button"
                onClick={handlePrintImageIframe}
                className="btn-blank"
              >
                <i className="fas fa-print text-white icon-print bg-dark" />
              </button>
            </div>
            <iframe
              id="imageIframe"
              ref={imageIframe}
              style={{
                display: 'block',
                width: '100%',
                height: '100%',
                border: 'none',
                objectFit: 'contain',
              }}
              title="View Image/Document"
            />
          </div>
          <div
            className={`${
              options.find((option) => option.value === currentFile)?.type !==
              'application/pdf'
                ? 'd-none'
                : 'd-flex'
            } justify-content-center align-items-center overflow-auto border`}
            style={{
              height: '600px',
            }}
          >
            <iframe
              style={{
                width: '100%',
                height: 600,
                border: 'none',
                display: 'flex',
                justifyContent: 'center',
              }}
              title="View Image/Document"
              src={currentFile}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </div>
    </Modal.Body>
  );
}
PrintDocument.defaultProps = {
  data: [],
};
PrintDocument.propTypes = {
  data: PropTypes.instanceOf(Array),
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PrintDocument);
